<template>
    <el-dialog
        :visible.sync="dialogShow"
        width="550px"
        top="30vh"
        :lock-scroll="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <div class="zhuanfa_dialog_bg">
            <div class="zhuanfa_now_title">
                <span v-if="isApp">该问卷只允许app作答，请扫码<br />下载app作答</span>
                <span v-else>该问卷只允许手机端作答，请扫码<br />前往微信小程序作答</span>
            </div>
            <div v-if="isApp" style="justify-content: center; margin: 20px 0;" class="zhuanfa_now_content">
                <img style="height: 165px;" 
                    class="credamo_QR_img" 
                    :src="cdn_img_prefix + '/partner/downloadAppQr.png'" 
                    draggable="false"/>
            </div>
            <div v-else style="justify-content: center;" class="zhuanfa_now_content">
                <vue-qr class="code" 
                    :text="codeUrl" 
                    ref="home_sruveyZhuanfa_qr" 
                    :size="180" 
                    style="justify-content: center;align-items: center;" 
                    :logoSrc="cdn_logo" 
                    :logoMargin='5'>
                </vue-qr>
            </div>
        </div>
    </el-dialog>
</template>

<style scoped>
.zhuanfa_now_title{
    font-size: 18px;
    font-weight: bold;
    padding: 30px 0 5px;
    text-align: center;
    color: #333;
}
.zhuanfa_now_content {
    display: flex;
}
</style>

<script>
import { commonParams } from '@/config/common'
import VueQr from 'vue-qr'
export default {
    props: {
        show: Boolean,
        isApp: Boolean,
        codeUrl: String
    },
    computed: {
        cdn_logo(){
            return commonParams.CDN_LOGO
        },
        cdn_img_prefix(){
            return commonParams.CDN_IMG_PREFIX
        },
        dialogShow: {
            get(){
                return this.show
            },
            set(val){
                this.$emit('update:show', val)
            }
        }
    },
    components: {
        VueQr
    }
}
</script>


// WEBPACK FOOTER //
// src/components/data-market/limit-dialog.vue